import Skeleton from '@mui/material/Skeleton'

const InputSkeleton = () => <Skeleton variant="rectangular" height={56} />

export default InputSkeleton
